import { filterService } from '@services/filterService';
import type { ApiFilterResponse } from '@interfaces/filter.types';

let initialized = false;

let brandValues: string[] = [];
let bodyTypeValues: string[] = [];
let fuelTypeValues: string[] = [];
let transmissionValues: string[] = [];
let budgetValues: string[] = [];
let seatingCapacityValues: string[] = [];

const hasCompleteFilterValues = () =>
  brandValues.length > 0 &&
  bodyTypeValues.length > 0 &&
  fuelTypeValues.length > 0 &&
  transmissionValues.length > 0 &&
  budgetValues.length > 0 &&
  seatingCapacityValues.length > 0;

const mapFilterValues = <T>(
  items: T[] | null | undefined,
  getValue: (item: T) => string | undefined | null
) => {
  if (!Array.isArray(items)) return null;

  return items
    .map((item) => getValue(item)?.toLowerCase())
    .filter((value): value is string => Boolean(value));
};

const setFilterValuesFromData = (data: ApiFilterResponse | null) => {
  if (!data) return;

  const nextBrandValues = mapFilterValues(data.brand_model, (brand: any) => brand.brand_value);
  const nextBodyTypeValues = mapFilterValues(data.body_type, (bodyType: any) => bodyType.value);
  const nextFuelTypeValues = mapFilterValues(data.fuel_type, (fuelType: any) => fuelType.value);
  const nextTransmissionValues = mapFilterValues(data.transmission, (transmission: any) => transmission.value);
  const nextBudgetValues = mapFilterValues(data.budget_range, (budget: any) => budget.value);
  const nextSeatingCapacityValues = mapFilterValues(data.seat_capacity, (seat: any) => seat.value);

  if (nextBrandValues) brandValues = nextBrandValues;
  if (nextBodyTypeValues) bodyTypeValues = nextBodyTypeValues;
  if (nextFuelTypeValues) fuelTypeValues = nextFuelTypeValues;
  if (nextTransmissionValues) transmissionValues = nextTransmissionValues;
  if (nextBudgetValues) budgetValues = nextBudgetValues;
  if (nextSeatingCapacityValues) seatingCapacityValues = nextSeatingCapacityValues;

  initialized = hasCompleteFilterValues();
};

export const hydrateFilterCache = (filterData?: ApiFilterResponse | null) => {
  if (!filterData) return;
  setFilterValuesFromData(filterData);
};

export const initFilterCache = async (filterData?: ApiFilterResponse | null) => {
  if (initialized && hasCompleteFilterValues()) return;

  if (filterData) {
    hydrateFilterCache(filterData);
    return;
  }

  const data = await filterService.getFilters();
  setFilterValuesFromData(data);
};

export const getFilterValues = () => {
  return {
    brandValues,
    bodyTypeValues,
    fuelTypeValues,
    transmissionValues,
    budgetValues,
    seatingCapacityValues
  };
};
